import { render, staticRenderFns } from "./Link.CarouselItem.vue?vue&type=template&id=0ea310d3&scoped=true&"
import script from "./Link.CarouselItem.vue?vue&type=script&lang=js&"
export * from "./Link.CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./Link.CarouselItem.vue?vue&type=style&index=0&id=0ea310d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea310d3",
  null
  
)

export default component.exports